'use client'

import { ODDLE_PASS_JS_URL } from '@/libs/config/client'
import dynamic from 'next/dynamic'
import Script from 'next/script'
import { useEffect } from 'react'
import { ChunkLoadErrorHandler } from '@/utils/chunkLoadErrorHandler'

// Lazy load heavy components
const ExternalScript = dynamic(
  () => import('@/components/common/ExternalScript/ExternalScript'),
  {
    ssr: false,
    loading: () => null,
  }
)

const Toaster = dynamic(
  () =>
    import('oddle-shop-monorepo.design-system').then((mod) => ({
      default: mod.Toaster,
    })),
  {
    ssr: false,
    loading: () => null,
  }
)

export const ClientScripts = () => {
  useEffect(() => {
    // Initialize error handlers and logging
    ChunkLoadErrorHandler.init()
  }, [])

  return (
    <>
      <Script async src={ODDLE_PASS_JS_URL} />
      <ExternalScript />
      <Toaster
        position="top-right"
        className="!top-[80px]"
        toastOptions={{
          classNames: {
            success: '!bg-[#067E30] !text-[#DDF7E6]',
            error: '!bg-[#D62105] !text-[#FFEEEB]',
            info: '!bg-[#0C62CA] !text-[#D7E9FF]',
            warning: '!bg-[#FFCF35] !text-[#000000]',
          },
          duration: 2000,
        }}
      />
    </>
  )
}
